import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

export default function ImageFilePreview(props) {
  let { src, caption } = props;

  return (
    <Row className={'justify-content-center'}>
      <Col xs={3}>
        <div className={'d-flex flex-column justify-content-center'}>
          <img className={'w-100 d-block'} src={src} />
          {caption && <p className={'text-primary text-center'}>{caption}</p>}
        </div>
      </Col>
    </Row>
  );
}

ImageFilePreview.propTypes = {
  src: PropTypes.string.isRequired,
  caption: PropTypes.string,
};
